<template>
    <footer class="main-footer">
        <div class="container-1">
            <div class="main-footer__sarafan-logo">Sarafan Technology</div>
            <div class="main-footer__top">
                <div class="main-footer__top-left">
                    <div class="main-footer__links">
                        <div class="main-footer__link-wrap">
                            <router-link to="/" class="main-footer__link">{{ $t('main.header.link1') }}</router-link>
                        </div>
                        <div class="main-footer__link-wrap">
                            <router-link to="/video-data-service" class="main-footer__link">{{ $t('main.header.link2') }}</router-link>
                        </div>
                        <div class="main-footer__link-wrap">
                            <router-link to="/technology" class="main-footer__link">{{ $t('main.header.link3') }}</router-link>
                        </div>
                        <div class="main-footer__link-wrap">
                            <router-link to="/about" class="main-footer__link">{{ $t('main.header.link4') }}</router-link>
                        </div>
                    </div>
                </div>
                <div v-if="isRussianIP" class="main-footer__top-right">
                    <a href="https://sk.ru" target="_blank" class="main-footer__skolkovo-logo">
                        <img src="/images/skolkovo-color.svg" alt="Skolkovo logo" width="160" height="114">
                    </a>
                </div>
            </div>
            <div v-if="isRussianIP" class="main-footer__skolkovo-description">
                Исследования осуществляются при грантовой поддержке Фонда «Сколково»
            </div>
            <h3 class="main-footer__subtitle">{{ $t('main.footer.contacts') }}</h3>
            <div class="main-footer__bottom">
                <div class="main-footer__bottom-left">
                    <div class="main-footer__contacts-container">
                        <div class="main-footer__contacts">
                            <div class="main-footer__contact">
                                {{ $t('main.footer.newYork') }}:
                                <a href="tel:+13474804426">+1 347 480 44 26</a>
                            </div>
                            <div class="main-footer__contact">
                                {{ $t('main.footer.saintPetersburg') }}:
                                <a href="tel:+78124247935">+7 812 424 79 35</a>
                            </div>
                        </div>
                        <div class="main-footer__contact email">
                            {{ $t('main.footer.email') }}:
                            <a href="mailto:hi@sarafan.tech" target="_blank">hi@sarafan.tech</a>
                        </div>
                    </div>
                    <div v-if="isRussianIP" class="main-footer__address">
                        ООО «Сарафан Технологии» ОГРН 1157847406870 ИНН 7814296832 ОКВЭД 62.01 Разработка компьютерного программного обеспечения
                        Адрес: 197022, Российская Федерация, г. Санкт-Петербург, пр-кт Аптекарский, д.2, лит. 3, пом. 7-Н
                    </div>
                    <div class="main-footer__bottom-line">
                        <div class="main-footer__copyright">© 2022. Sarafan Technology. {{ $t('main.footer.rights') }}</div>
                        <div class="main-footer__extra-links">
                            <div class="main-footer__link-wrap">
                                <router-link to="/privacy-policy" class="main-footer__link">
                                    {{ $t('main.footer.privacyPolicy') }}
                                </router-link>
                            </div>
                            <div class="main-footer__link-wrap">
                                <router-link to="/terms-of-use" class="main-footer__link">
                                    {{ $t('main.footer.termsAndConditions') }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main-footer__bottom-right">
                    <div class="main-footer__link-wrap">
                        <router-link to="/privacy-policy" class="main-footer__link">
                            {{ $t('main.footer.privacyPolicy') }}
                        </router-link>
                    </div>
                    <div class="main-footer__link-wrap">
                        <router-link to="/terms-of-use" class="main-footer__link">
                            {{ $t('main.footer.termsAndConditions') }}
                        </router-link>
                    </div>
                    <div v-if="isRussianIP" class="main-footer__skolkovo-wrapper">
                        <a href="https://sk.ru" target="_blank" class="main-footer__skolkovo-logo">
                            <img src="/images/skolkovo-color.svg" alt="Skolkovo logo" width="168" height="112">
                        </a>
                        <div class="main-footer__skolkovo-description">
                            Исследования осуществляются при грантовой поддержке Фонда «Сколково»
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState(['isRussianIP'])
        }
    }
</script>